module.exports = __webpack_public_path__ + "img/ZL.099aeb4a.png";